import styled from 'styled-components';
import { ISvgComponent } from '../svg.models';

export const Svg = styled.svg<Pick<ISvgComponent, 'shrinkable'>>`
  ${({ shrinkable }) => (!shrinkable ? 'flex-shrink: 0;' : '')}
`;

